<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title></v-toolbar-title>
      <!-- <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider> -->
       <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
            <v-layout row>
              <v-flex xs12 sm6 offset-sm3>
                <v-card>
                  <v-img
                    v-if="editedItem.document.photo"
                    :src="userImage + editedItem.document.photo"
                    class="my-3"
                    contain
                    aspect-ratio="1.4"
                  >
                 
                    <v-layout
                      column
                      fill-height
                    >
                      <v-card-title>
                        <!-- <v-btn dark icon>
                          <v-icon>chevron_left</v-icon>
                        </v-btn>
                        
                        <v-spacer></v-spacer>

                        <v-btn dark icon class="mr-3">
                          <v-icon>edit</v-icon>
                        </v-btn>

                        <v-btn dark icon>
                          <v-icon>more_vert</v-icon>
                        </v-btn> -->
                      </v-card-title>

                      <v-spacer></v-spacer>

                      <v-card-title class="gray--text pl-5 pt-5">
                        <div class="display-1 pl-5 pt-5"><span class="green--text">{{editedItem.user_name}}</span></div>
                      </v-card-title>
                    </v-layout>
                  </v-img>

                  <v-list two-line>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="indigo">phone</v-icon>
                        <!-- <v-icon color="indigo">mail</v-icon> -->
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>{{ editedItem.phone }}</v-list-tile-title>
                        <!-- <v-list-tile-title>zrshishir@gmail.com</v-list-tile-title> -->
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-icon color="indigo" v-if="editedItem.borrower_status == 1">radio_button_checked</v-icon>
                        <v-icon color="indigo" v-else>radio_button_unchecked</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>Active</v-list-tile-title>
                        <!-- <v-list-tile-title>Inactive</v-list-tile-title> -->
                      </v-list-tile-content>
                    </v-list-tile>
                    
                    <v-divider inset></v-divider>
                      <v-list-tile>
                          <v-list-tile-action>
                          <v-icon color="indigo">location_on</v-icon>
                          </v-list-tile-action>

                          <v-list-tile-content>
                          <v-list-tile-title>{{ editedItem.present_address }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ editedItem.present_address }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                      </v-list-tile>
                      </v-list>
                </v-card>
                <v-divider inset></v-divider>
                    <v-container fluid>
                      <v-list-tile-title class="font-weight-bold text-sm-center">Funding Details</v-list-tile-title>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card>
                                  <v-card-text class="px-1">Amount</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.amount }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card>
                                  <v-card-text class="px-1" >Duration</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.duration }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Disbursed Amount</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.disbursed_amount }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Monthly Funding Due</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.monthly_funding_due }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Monthly Community Fee</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.monthly_community_fee }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Shadhin Onetime Fee</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.shadhin_one_time_fee }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Monthly Payment Gateway Fee</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.monthly_payment_gateway_fee }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Total Monthly Payable</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.total_monthly_payable }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Total Full Term Payable</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.total_full_term_payable }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Outstanding</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ (editedItem.outstanding) ? editedItem.outstanding : 0}}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Loan Purpose</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.loan_purpose }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                      </v-container>
                    <v-container fluid>
                      <v-list-tile-title class="font-weight-bold text-sm-center">Basic Information</v-list-tile-title>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card>
                                  <v-card-text class="px-1">Present Address</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.present_address }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card>
                                  <v-card-text class="px-1" >Division</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.division_name }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">District</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.district_name }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Gender</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.gender }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Date of Birth</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.dob }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Marital Status</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.marital_status }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">National ID Card No</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.nid }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Gini Score</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ (editedItem.gini_score) ? editedItem.gini_score : 'no'}}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                      </v-container>
                  <!-- <v-divider inset></v-divider> -->
                    <v-container fluid>
                      <v-list-tile-title class="font-weight-bold text-sm-center">Professional Information</v-list-tile-title>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card>
                                  <v-card-text class="px-1">Employment Type</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.employment_type }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card>
                                  <v-card-text class="px-1" >Monthly Income</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.monthly_income }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Educaitonal Qualification</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.educational_qualification }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Institute Name</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.institute_name }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Out Loan Availability</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.out_loan_availability }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Out Loan No</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.out_loan_no }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                      </v-container>
                    
                      <v-container fluid v-if="editedItem.out_loan_availability == 1">
                        <v-list-tile-title class="font-weight-bold text-sm-center">Out Loan Informations</v-list-tile-title>
                        <v-layout row justify-space-around>
                            <v-flex xs4>
                              <v-card >
                                  <v-card-text class="px-1">Out Loan Type</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs4>
                              <v-card >
                                  <v-card-text class="px-1">Out Loan Amount</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs4>
                              <v-card >
                                  <v-card-text class="px-1">Out Loan EMI/Month</v-card-text>
                              </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout row justify-space-around v-for="loan in editedItem.out_loan_info" :key="loan.id">
                            <v-flex xs4>
                              <v-card >
                                  <v-card-text class="px-1">{{ loan.out_loan_type }}</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs4>
                              <v-card >
                                  <v-card-text class="px-1">{{ loan.out_loan_amount }}</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs4>
                              <v-card >
                                  <v-card-text class="px-1">{{ loan.out_loan_emi }}</v-card-text>
                              </v-card>
                            </v-flex>
                        </v-layout>
                      </v-container>
                          <!-- Bank Details Information -->
                      <v-container fluid v-if="editedItem.account_type">
                        <v-list-tile-title class="font-weight-bold text-sm-center">Bank Details</v-list-tile-title>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card>
                                  <v-card-text class="px-1">Bank Name</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.bank_detail.bank_name }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card>
                                  <v-card-text class="px-1" >Receiver Name</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.bank_detail.receiver_name }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Account No</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.bank_detail.account_no }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Bank Routing No</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.bank_detail.bank_routing_no }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-space-around>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">Account Type</v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs6>
                              <v-card >
                                  <v-card-text class="px-1">{{ editedItem.account_type }}</v-card-text>
                              </v-card>
                            </v-flex>
                          </v-layout>
                      </v-container>
                      <!-- Bank Details end  -->
                  </v-flex>
            </v-layout>
            
                  <!-- <v-divider inset></v-divider> -->
                      <v-container fluid>
                        <v-list-tile-title class="font-weight-bold text-sm-center" color="red">Upload Docs</v-list-tile-title>
                          <v-layout row>
                              <v-flex xs6 mr-1>
                                <div class="subheading">National ID Card Front Page</div>
                                <v-img :src="docImage + editedItem.document.nid_front_page" aspect-ratio="1.4"></v-img>
                              </v-flex>
                              <v-flex xs6 ml-1>
                                <div class="subheading">National ID Card Back Page</div>
                                <v-img :src="docImage + editedItem.document.nid_back_page" aspect-ratio="1.4"></v-img>
                              </v-flex>
                          </v-layout>
                          <v-layout row>
                              <v-flex xs6 mr-1>
                                <div class="subheading pt-3">Birth Certificate</div>
                                <v-img :src="docImage + editedItem.document.birth_certificate" aspect-ratio="1.4"></v-img>
                              </v-flex>
                              <v-flex xs6 ml-1>
                                <div class="subheading pt-3">Other Govt. Issued ID</div>
                                <v-img :src="docImage + editedItem.document.other_gov_issued_id" aspect-ratio="1.4" ></v-img>
                              </v-flex>
                          </v-layout>
                          <v-layout row>
                              <v-flex xs6 mr-1>
                                <div class="subheading pt-3">Salary Certificate</div>
                                <v-img :src="docImage + editedItem.document.salary_certificate" aspect-ratio="1.4"></v-img>
                              </v-flex>
                              <v-flex xs6 ml-1>
                                <div class="subheading pt-3">Utility Bill</div>
                                <v-img :src="docImage + editedItem.document.electricity_bill" aspect-ratio="1.4" ></v-img>
                              </v-flex>
                          </v-layout>
                          <v-layout row>
                              <v-flex xs6 mr-1>
                                <div class="subheading pt-3">Bank Statement First Page</div>
                                <v-img :src="docImage + editedItem.document.bank_statement_first_page" aspect-ratio="1.4"></v-img>
                              </v-flex>
                              <v-flex xs6 ml-1>
                                <div class="subheading pt-3">Bank Statement Last Page</div>
                                <v-img :src="docImage + editedItem.document.bank_statement_last_page" aspect-ratio="1.4"></v-img>
                              </v-flex>
                          </v-layout>
                          <v-layout row>
                              <v-flex xs6 mr-1>
                                <div class="subheading">Additional Document 1</div>
                                <v-img :src="docImage + editedItem.document.additional_document1" aspect-ratio="1.4"></v-img> 
                              </v-flex>
                              <v-flex xs6 ml-1>
                                <div class="subheading">Additional Document 2</div>
                                <v-img :src="docImage + editedItem.document.additional_document2" aspect-ratio="1.4"></v-img>
                              </v-flex>
                          </v-layout>
                          <v-layout row>
                              <v-flex xs6 mr-1>
                                <div class="subheading">Additional Document 3</div>
                                <v-img :src="docImage + editedItem.document.additional_document3" aspect-ratio="1.4"></v-img>
                              </v-flex>
                              <v-flex xs6 ml-1>
                                <div class="subheading">Additional Document 3</div>
                                <v-img :src="docImage + editedItem.document.additional_document3" aspect-ratio="1.4"></v-img>
                              </v-flex>
                          </v-layout>
                          <v-layout row v-if="editedItem.investee_agreement && editedItem.investor_agreement">
                              <v-flex xs6 mr-1>
                                <div class="subheading">Investor Agreement</div>
                                <v-img :src="investorAgreement + editedItem.investor_agreement" aspect-ratio="1.4"></v-img>
                              </v-flex>
                              <v-flex xs6 ml-1>
                                <div class="subheading">Investee Agreement</div>
                                <v-img :src="investeeAgreement + editedItem.investee_agreement" aspect-ratio="1.4"></v-img>
                              </v-flex>
                          </v-layout>
                          <v-layout row>
                              <div>
                                  <v-btn color="success" @click="close">approve</v-btn>
                                  <!-- <v-btn color="indigo">Disbursed</v-btn> -->
                                 <v-btn color="red" @click="close">Cancel</v-btn>
                                  <!-- <v-btn color="warning" @click="close">Reject</v-btn> -->
                              </div>
                        </v-layout>
                      </v-container>
          </template>
      </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
     <div v-if="alertMsg">
        <v-alert v-if="error == 0 && statusCode == 200" :value="true" type="success" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && statusCode == 204" :value="true" type="info" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && (statusCode == 403 || statusCode == 400)" :value="true" type="warning" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && statusCode == 500" :value="true" type="error" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
     </div>
     <div v-if="indexData.length < 1" class="text-xs-center">
       <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>

     </div>
    <v-data-table
      :headers="headers"
      :items="indexData"
      :search="search"
      class="elevation-1"
    >
     <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ props.header.text }}
            </span>
          </template>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
     
      <template v-if="indexData.length > 0" v-slot:items="props">
        <!-- <td>{{ props.index + 1 }}</td> -->
        <td v-if="props.item.tran_status == 3">{{ props.item.transaction_id }}</td>
        <td v-if="props.item.tran_status == 3">{{ props.item.user.name }}</td>
        <td v-if="props.item.tran_status == 3">{{ props.item.user.phone }}</td>
        <td v-if="props.item.tran_status == 3">{{ props.item.title }}</td>
        <td v-if="props.item.tran_status == 3">{{ props.item.amount }}</td>
        <td v-if="props.item.tran_status == 3">{{ props.item.status.status_for }}</td>
        <td v-if="props.item.tran_status == 3">{{ (props.item.investor_payment_method) ?  (props.item.investor_payment_method.title) : "No"}}</td>
        <td v-if="props.item.tran_status == 3">{{ props.item.created_at }}</td>
        <td v-if="props.item.tran_status == 3">{{ props.item.updated_at }}</td>
        <!-- <td v-if="props.item.tran_status == 3" class="justify-center layout px-1"> -->
          <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small class="mr-2" v-on="on" @click="editItem(props.item)">
                    visibility
                </v-icon>
              </template>
            <span>view</span>
          </v-tooltip> -->
          <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small class="mr-2" v-on="on" @click="approveItem(props.item)">
                    done
                </v-icon>
              </template>
            <span>approve</span>
          </v-tooltip> -->
        <!-- </td> -->
      </template>
      <template v-else v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">
          {{ errorMsg }}
        </v-alert>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

  export default {
    data: () => ({
      dialog: false,
      alertMsg: false,
      apiUrl: 'withdraw',
      routePath: '/withdraw',
      sl: 1,
      headers: [
        { text: 'Transaction ID', value: 'transaction_id'},
        { text: 'Name', align: 'left', sortable: false, value: 'name' },
        { text: 'Phone', value: 'phone' },
        { text: 'Title', value: 'title' },
        { text: 'Amount', value: 'amount' },
        { text: 'Status', value: 'status' },
        { text: 'Payment Method', value: 'investor_payment_method' },
        { text: 'Applied Date', value: 'created_at'},
        { text: 'Disbursed Date', value: 'created_at'},
        // { text: 'Actions', align: 'center', value: 'name', sortable: false }
      ],
      desserts: [],
      search: '',
      editedIndex: -1,
      editedItem: {
        id: '',
        phone:'',
        amount: '',
        duration: '',
        disbursed_amount: '',
        monthly_funding_due: '',
        monthly_community_fee: '',
        shadhin_one_time_fee: '',
        monthly_payment_gateway_fee: '',
        total_monthly_payable: '',
        total_full_term_payable: '',
        outstanding: '',
        loan_purpose:'',
        loan_status_id:'',
        borrower_status: '',
        investor_agreement:'',
        investee_agreement:'',
        present_address:'',
        division_name:'',
        district_name:'',
        gender:'',
        marital_status:'',
        dob:'',
        nid:'',
        gini_score:'',
        employment_type:'',
        monthly_income:'',
        educational_qualification:'',
        institute_name:'',
        out_loan_availability:'',
        out_loan_no:'',
        account_type:'',
        document:{
          id:'',
          photo:'',
          nid_back_page:'',
          nid_front_page:'',
          birth_certificate:'',
          other_gov_issued_id:'',
          salary_certificate:'',
          electricity_bill:'',
          bank_statement_first_page:'',
          bank_statement_last_page:'',
          additional_document1:'',
          additional_document2:'',
          additional_document3:'',
          
        }, 
        bank_detail:{
          id:'',
          bank_name:'',
          receiver_name:'',
          account_no:'',
          bank_routing_no:'',
        },
        out_loan_info:[]
      },
      defaultItem: {
        
      }
    }),
    
    computed: {
      ...mapGetters(['indexData', 'error', 'statusCode', 'errorMsg', 'investorAgreement', 'investeeAgreement', 'userImage', 'docImage']),
      formTitle () {
        return this.editedIndex === -1 ? 'New Application' : 'View Application'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    // created () {
    //   this.initialize('indexData')
    //   this.$store.dispatch('indexData', this.apiUrl)
    // },

    methods: {
      initialize () {
        this.$store.dispatch('indexData', ['withdraw', 3])
        this.alertMsg = true
        setTimeout(() => {
          this.alertMsg = false
        }, 300)
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.indexOf(item)
        this.editedItem = Object.assign({}, item)
        // this.dialog = true
      },

      // rejectItem (item) {
      //   // console.log(item.id)
      //   const index = this.indexData.indexOf(item)
      //   confirm('Are you sure you want to approve this application?') && this.indexData.splice(index, 1)
      //   this.$store.dispatch('changeStatus',[ item.id, 'reject', this.routePath])
      //   // this.$store.dispatch('indexData', this.apiUrl)
      //   this.close()
      //   setTimeout(() => {
      //     this.alertMsg = false
      //   }, 300)
      // },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem
</style>